var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stripe-input-wrapper" },
    [
      _vm.isStatusLoading
        ? _c("LoadingAnimation", {
            staticClass: "w-100 d-flex align-items-center",
            staticStyle: { height: "55px" },
            attrs: { "animation-style": "bars" },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        { staticStyle: { width: "100%" }, attrs: { id: "payment-form" } },
        [
          _c("div", { attrs: { id: "payment-element" } }),
          _vm._v(" "),
          _vm.cardError
            ? _c(
                "div",
                { staticClass: "stripe-error-container text-danger mt-1" },
                [_vm._v(_vm._s(_vm.cardError))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "justify-content-center d-flex align-items-center text-muted font-size-75 mt-1",
            },
            [
              _c("i", { staticClass: "mr-1 fa fa-lock" }),
              _vm._v(
                " " +
                  _vm._s(
                    _vm._f("trans")("All transactions are SSL encrypted.")
                  ) +
                  "\n        "
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }